module.exports = __webpack_public_path__ + "static/media/diners.dabcf99a.svg";